import { useEffect } from "react";
import { X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

export function toYouTubeEmbed(url) {
  if (!url) return null;
  const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([A-Za-z0-9_-]{6,})/);
  if (m) return `https://www.youtube.com/embed/${m[1]}?autoplay=1&rel=0&modestbranding=1`;
  return url.match(/\.(mp4|webm|mov)(\?|$)/i) ? url : null;
}

export default function FounderVideoModal({ url, title, onClose }) {
  const embed = toYouTubeEmbed(url);
  const isFile = embed && !embed.includes("youtube.com/embed");

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <AnimatePresence>
      <motion.div
        data-testid="founder-video-modal"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[80] flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.94, y: 12 }}
          animate={{ scale: 1, y: 0 }}
          className="relative w-full max-w-3xl overflow-hidden rounded-2xl border-2 border-white/20 bg-black shadow-[8px_8px_0px_rgba(0,0,0,0.5)]"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            data-testid="founder-video-close"
            onClick={onClose}
            aria-label="Close video"
            className="absolute right-3 top-3 z-10 flex h-9 w-9 items-center justify-center rounded-full border-2 border-white/40 bg-black/60 text-white transition-colors hover:bg-white hover:text-black"
          >
            <X className="h-4 w-4" />
          </button>
          <div className="aspect-video w-full">
            {isFile ? (
              <video src={embed} controls autoPlay className="h-full w-full" />
            ) : (
              <iframe
                src={embed}
                title={title}
                className="h-full w-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            )}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
